var exports = {
  "n": "xfd349460--29459a--link",
  "U": "xfd349460--29459a--arrow",
};

module.exports = exports;
